import { APIS } from '@/constants';
import { apisUtility } from '@/utils';
import axios from 'axios';

const ekycApi = {
  /**
   *
   * @param {String} token
   * @param {Object} parameters
   * @returns {AxiosPromise}
   */
  requestList(token, parameters) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = apisUtility.bindValuedParams(parameters);
    return axios({
      url: '/list',
      method: 'get',
      baseURL: APIS.BASE_URL.EKYC,
      headers,
      params,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestKycKybSummary(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/kyc_kyb_summary',
      method: 'get',
      baseURL: APIS.BASE_URL.EKYC,
      headers,
    });
  },
};

export default ekycApi;
